import type { GraphEdge, GraphNode } from "@salesko/contracts";

const MaxStableAuditTextLength = 500;
const StableGraphFrameSummaryPrefix = "Agent graph frame:";

// Stable English payload text for persisted graph frames, change-set reasons, and audit messages.
// UI copy must come from i18n dictionaries; these values intentionally do not.
export function stableAuditText(value: string) {
  return value.slice(0, MaxStableAuditTextLength);
}

export function stableReviewCommitMessage(action: string, nodeLabel: string) {
  return stableAuditText(`Review ${action}: ${nodeLabel}`);
}

export function stableTimelineReplayReason(label: string) {
  return stableAuditText(`Save timeline replay: ${label}`);
}

export function stableRelationshipCreateReason(sourceLabel: string, targetLabel: string) {
  return stableAuditText(`Create relationship: ${sourceLabel} -> ${targetLabel}`);
}

export function stableRelationshipEditReason(label: string) {
  return stableAuditText(`Edit relationship: ${label}`);
}

export function stableRelationshipDeleteReason(label: string) {
  return stableAuditText(`Delete relationship: ${label}`);
}

export function stableRelationshipTouchpointReason(label: string) {
  return stableAuditText(`Log touchpoint: ${label}`);
}

export function stableGraphFrameTitle() {
  return "Graph frame";
}

export function stableGraphFrameTag() {
  return "graph";
}

export function stableGraphFrameAbout() {
  return "Agent generated a graph-native visualization frame.";
}

export function stableConfidenceTag(confidence: number) {
  return `${Math.round(confidence * 100)}% confidence`;
}

export function stableReviewFocusReason() {
  return "Selected reviewed candidate.";
}

export function stableTimelineMomentSummary() {
  return "Event moment extracted by the agent.";
}

export function stableGraphFrameSummary(nodes: GraphNode[], edges: GraphEdge[]) {
  const people = nodes.filter((node) => node.type === "person").length;
  const organisations = nodes.filter((node) => node.type === "organisation").length;
  return `${StableGraphFrameSummaryPrefix} ${nodes.length} nodes, ${edges.length} relationships, ${people} people, ${organisations} organisations.`;
}

export function stableGraphFrameSummaryTitle(summary: string) {
  return summary.replace(new RegExp(`^${escapeRegExp(StableGraphFrameSummaryPrefix)}\\s*`, "i"), "").trim();
}

function escapeRegExp(value: string) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
